import { CircularSpinner } from '@festina-life/ui/feedback'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import { typographyStyles } from '@festina-life/ui/structure'
import cx from 'classnames'

type Props = {
  count: number
  isLoading?: boolean
}

export const ErrorCount = ({ count, isLoading }: Props) => {
  const translate = useTranslate()

  return (
    <div
      className={cx(
        `rounded-md px-2 flex flex-row gap-x-2 items-center justify-center min-w-25`,
        typographyStyles({ intensity: 'primary' }),
        {
          'bg-error-400 dark:bg-error-600': !!count && !isLoading,
          'bg-success-300 text-amaze-ink!': !count && !isLoading,
        },
        isLoading ? paperStyles({ isFaded: true }) : undefined,
      )}
    >
      {!!isLoading && (
        <CircularSpinner className="size-4 text-amaze-inkBright" />
      )}
      {!isLoading
        ? translate('workspaceManager.option.errors', {
            count,
          })
        : translate('workspaceManager.option.validating')}
    </div>
  )
}
